import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { normalisePath, trackPageView } from '../config/telemetry';

/**
 * Emits an App Insights page view on every route change.
 *
 * Renders nothing — it exists purely for the effect, and must sit INSIDE
 * <Router> so useLocation() has a router to read.
 *
 * Manual rather than the SDK's enableAutoRouteTracking: that hooks the History
 * API and reports raw URLs, so /containers/1234 and /containers/1235 become two
 * different pages. normalisePath collapses ids to :id, which is what makes
 * "which screens do people actually use" a question with an answer.
 */
export default function RouteTelemetry() {
  const location = useLocation();

  useEffect(() => {
    const name = normalisePath(location.pathname) || '/';
    trackPageView(name, window.location.href);
  }, [location.pathname]);

  return null;
}
